import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GenericComponent } from '../generic/generic.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { Store } from '@ngxs/store';

@UntilDestroy()
@Component({
    selector: 'app-transformer-others',
    templateUrl: './transformer-others.component.html',
    styleUrls: ['./transformer-others.component.scss'],
})
export class TransformerOthersComponent extends GenericComponent {
    constructor(
        private readonly route: ActivatedRoute,
        private readonly sidenavService: SidenavService,
        private readonly store: Store,
    ) {
        super(route, sidenavService, store);
    }
}
